import {
    LOADED_USERS,
    LOADED_USERS_TOTAL,
    LOADED_USERS_PAGES,
    LOADED_USERS_CURRENT,
    LOADED_USERS_LIMIT,
    SET_USER,
    LOADED_ME,
    AUTH_CODE_ISSUED,
    LOADED_ME_DISTRICT_SUBSCRIPTION,
    LOADED_ME_PREFERENCES,
    LOADED_ME_SCHOOL_SUBSCRIPTION,
} from "../actions/user_actions";

const searchParams = new URLSearchParams(location.search);

const users = (payload = [], action) => {
    switch (action.type) {
        case LOADED_USERS:
            return action.payload;
        default:
            return payload;
    }
};
const users_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_USERS_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const users_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_USERS_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const users_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_USERS_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const users_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_USERS_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};

const user = (payload = null, action) => {
    switch (action.type) {
        case SET_USER:
            return action.payload;
        default:
            return payload;
    }
};
const me = (state = null, action) => {
    switch (action.type) {
        case LOADED_ME:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};
const auth_code = (state = false, action) => {
    switch (action.type) {
        case AUTH_CODE_ISSUED:
            return action.payload;
        default:
            return state;
    }
};

const me_district_subscription = (payload = null, action) => {
    switch (action.type) {
        case LOADED_ME_DISTRICT_SUBSCRIPTION:
            return action.payload;
        default:
            return payload;
    }
};
const me_school_subscription = (payload = null, action) => {
    switch (action.type) {
        case LOADED_ME_SCHOOL_SUBSCRIPTION:
            return action.payload;
        default:
            return payload;
    }
};
const me_preferences = (payload = [], action) => {
    switch (action.type) {
        case LOADED_ME_PREFERENCES:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    users,
    users_current,
    users_total,
    users_pages,
    users_limit,
    user,
    me,
    onAuth: auth_code,
    me_district_subscription,
    me_school_subscription,
    me_preferences
}
